import { ApiResourceBaseClass as s } from "./baseApiCalls.js";
const o = "google-oauth-accounts", t = "facebook-oauth-accounts", n = {
  GOOGLE_MY_BUSINESS: o,
  gmb: o,
  FACEBOOK: t,
  facebook: t
};
class O extends s {
  /**
   * Retrieves location details for a given Google account.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/api/v2/{partner}/locations/{locationId}`
   *
   * @param {string} locationId - The ID of the location
   * @param {AccountPartnerResourceName | AccountPartner} partner - The partner type (e.g., GOOGLE_MY_BUSINESS)
   * @returns {Promise<V2LocationData>} A promise that resolves to the location data
   */
  getLocationDetail = async (a, c) => {
    const { data: e } = await this.get(
      `${n[c]}/locations/${a}`,
      { partoo_ui: "True" }
    );
    return e;
  };
}
export {
  O as Account,
  n as partnerToResourceUri
};
